import React, { createRef, useEffect, useState } from "react";
import { useOnScreen } from "../../components/useOnScreen";
import { Title, Wrapper } from "../../GlobalStyle";
import { ClientsWrapper } from "./Styled";

function ClientItem({ picture, isVisible, delay }) {
  const animateRef = createRef();
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      animateRef.current = setTimeout(() => {
        setIsShow(true);
      }, delay);
    } else {
      setIsShow(false);
    }

    return () => clearTimeout(animateRef.current);
  }, [isVisible]);

  return (
    <img
      className={isShow ? "active" : ""}
      src={picture}
      alt="SEEDverse Client"
    />
  );
}

function Clients() {
  const imagesArr = [...new Array(4).keys()].map((item, index) =>
    require(`../../images/client${index + 1}.png`)
  );
  const containerRef = createRef();
  const isVisible = useOnScreen(containerRef);

  return (
    <ClientsWrapper id="clients" ref={containerRef}>
      <Wrapper>
        <Title>Our Clients</Title>
        <div className="clients-container">
          {imagesArr.map((item, index) => (
            <ClientItem
              picture={item}
              isVisible={isVisible}
              delay={index * 100}
              key={`client${index}`}
            />
          ))}
        </div>
      </Wrapper>
    </ClientsWrapper>
  );
}
export default Clients;
